// app/javascript/controllers/typeahead_controller.js

import { Controller } from "@hotwired/stimulus"
import $ from "jquery";
import "typeahead.js/dist/typeahead.jquery"; // jQuery plugin
import "typeahead.js"; // registers Bloodhound globally

console.log("🔄 typeahead_controller.js reloaded");

export default class extends Controller {
  static targets = ["input"]
  static values = {
    texts: Array,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    console.log("✅ Typeahead + Placeholder controller connected:", this.identifier)

    this.setupTypeahead()
    this.startPlaceholderRotation()
  }

  disconnect() {
    this.stopPlaceholderRotation()
  }

  // 🔍 Setup typeahead.js on input
  setupTypeahead() {
    const input = this.inputTarget

    if (!input) {
      console.warn("❌ No inputTarget found")
      return
    }

    if (typeof $.fn.typeahead !== "function") {
      console.warn("❌ typeahead is not available. Script may not have loaded.")
      return
    }

    if ($(input).hasClass("tt-input")) {
      console.log("⚠️ Typeahead already initialized on this input. Skipping.")
      return
    }

   const bloodhound = window.Bloodhound;

    if (!bloodhound) {
      console.warn("❌ Bloodhound not found");
      return;
    }

    const awards = new bloodhound({
      datumTokenizer: bloodhound.tokenizers.obj.whitespace("title"),
      queryTokenizer: bloodhound.tokenizers.whitespace,
      remote: {
        url: "/awards/typeahead?q=%QUERY",
        wildcard: "%QUERY"
      }
    });

    
    $(input).typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 2
      },
      {
        name: "awards",
        display: "title",
        source: awards,
        templates: {
          suggestion: function (data) {
            return `<a href="/awards/${data.id}" class="block px-4 py-2 bg-white hover:bg-gray-100">${data.title} ${data.id}</a>`
          }
        }
      }
    )
  }

  // 🔄 Placeholder animation
  startPlaceholderRotation() {
    if (!this.hasTextsValue || !this.inputTarget) return

    this.index = 0
    this.updatePlaceholder()
    this.timer = setInterval(() => this.updatePlaceholder(), this.intervalValue)
  }

  stopPlaceholderRotation() {
    clearInterval(this.timer)
  }

  updatePlaceholder() {
    const text = this.textsValue[this.index]
    this.inputTarget.placeholder = text
    this.index = (this.index + 1) % this.textsValue.length
  }
}
